<span [ngClass]="{ 'name': highlightName }"
      data-automation-e2e-selector="title">
    US {{treasury.securityId.replace('US', '')}}:
</span>
<span class="yield"
      data-automation-e2e-selector="yield">
    {{treasury.current.yield | number : numberFormat}}
    <span [class]="changeClass"
          data-automation-e2e-selector="delta">
        ({{yieldDiff | iexChange: numberFormat}})
    </span>
</span>